import Vue from 'vue';
import GhModal from '@/components/base/GhModal.vue';
import GhNotification from '@/components/base/GhNotification.vue';
import ImageSwiper from '@/components/base/ImageSwiper.vue';
import ListItem from '@/components/base/ListItem.vue';
import SvgIcon from '@/components/base/SvgIcon.vue';
import ProductFrame from '@/components/products/ProductFrame.vue';
import HomeNews from './HomeNews.vue';
import IndexPage from './IndexPage.vue';
import { installSharedRuntimeBridges, mountVuePage } from '@/main';
import { registerRuntimeComponents } from '@/runtime/components/register-components.runtime';
import { LazyLoader } from '@/utils/image/image-lazy-loader.utils';

type VueWithOptions = typeof Vue & {
    options?: {
        directives?: Record<string, unknown>;
    };
};

let isInstalled = false;

const installHomeIndexLazyDirective = (): void => {
    const vueWithOptions = Vue as VueWithOptions;
    if (vueWithOptions.options?.directives?.['lazy-img']) {
        return;
    }

    const lazyLoader = new LazyLoader({
        imageCacheMode: 'rewrite',
        placeholderOptions: {
            default: {
                format: 'webp',
                quality: 80,
                error: '/Images/ComingSoon.png',
            },
            'home-banner-desktop': {
                error: '/Content/doc/cht/banner/banner_loading.jpg',
                width: 1440,
            },
            'product-card-thumb': {
                width: 300,
            },
        },
    });
    lazyLoader.registerVueDirective('lazy-img');
};

/**
 * 安裝 home-index 入口所需 runtime
 */
const installHomeIndexRuntime = (): void => {
    if (isInstalled) return;

    installSharedRuntimeBridges();
    installHomeIndexLazyDirective();
    registerRuntimeComponents({
        'gh-modal': GhModal,
        'gh-notification': GhNotification,
        'image-swiper': ImageSwiper,
        'list-item': ListItem,
        'svg-icon': SvgIcon,
        'product-frame': ProductFrame,
        'home-news': HomeNews,
    });

    isInstalled = true;
};

installHomeIndexRuntime();

mountVuePage({
    selector: '#HomeIndexPageApp',
    appKey: 'home-index-page',
    render: (h) => h(IndexPage),
});
